module.exports = __webpack_public_path__ + "img/ozo_logo_header.76fed838.svg";